import Route from '@ember/routing/route';
import { set, get } from '@ember/object';
import { service } from '@ember/service';

export default Route.extend({
  fundsService: service(),
  store: service(),
  navbarSettings: service(),

  beforeModel() {
    set(this, 'navbarSettings.title', 'Delete Task');
    return this.fundsService.confirmValidFundToken();
  },

  model(params) {
    return this.store.findRecord('task', params.taskId);
  },
});
